import { styled } from '@mui/material';

export const CardStyled = styled('div')<{ $cardIsBig: boolean }>(
  ({ theme, $cardIsBig }) => ({
    heght: '100%',
    height: $cardIsBig ? theme.spacings.unit(152) : theme.spacings.unit(85),
    borderRadius: theme.borders.roundness,
    backgroundColor: `${theme.colors.background} !important`,
    color: theme.colors.primaryText,
    '&:hover': {
      boxShadow: theme.gradients.card,
      cursor: 'pointer',
    },
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  })
);

export const HeaderFieldContainer = styled('div')<{
  $cardIsBig: boolean;
}>(({ theme, $cardIsBig }) => ({
  width: '100%',
  marginBottom: $cardIsBig
    ? `${theme.spacings.unit(5)}`
    : `${theme.spacings.unit(3)}`,
  display: 'flex',
}));

export const FieldContainer = styled('div')<{
  $cardIsBig: boolean;
}>(({ theme, $cardIsBig }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacings.unit(2),
  width: '100%',
  alignItems: 'center',
  svg: {
    color: theme.colors.subtext,
    height: $cardIsBig ? theme.spacings.unit(6) : theme.spacings.unit(5),
    width: $cardIsBig ? theme.spacings.unit(6) : theme.spacings.unit(5),
  },
}));

export const HeaderFieldText = styled('span')<{
  $cardIsBig: boolean;
}>(({ theme, $cardIsBig }) => ({
  fontSize: $cardIsBig
    ? theme.fonts.utility.size(16)
    : theme.fonts.utility.size(10),
  fontWeight: theme.fonts.default.semiBold.fontWeight,
  color: theme.colors.primaryText,
  lineHeight: $cardIsBig ? theme.spacings.unit(10) : theme.spacings.unit(7),
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}));

export const FieldText = styled('span')<{ $cardIsBig: boolean }>(
  ({ theme, $cardIsBig }) => ({
    fontSize: $cardIsBig
      ? theme.fonts.utility.size(10)
      : theme.fonts.utility.size(8),
    color: theme.colors.primaryText,
    lineHeight: $cardIsBig ? theme.spacings.unit(7) : theme.spacings.unit(6),
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  })
);

export const CardDescriptionContainer = styled('div')<{
  $cardIsBig: boolean;
}>(({ theme, $cardIsBig }) => ({
  padding: $cardIsBig
    ? `
    ${theme.spacings.unit(6)} 
    ${theme.spacings.unit(3)}
  `
    : `
    ${theme.spacings.unit(4)}
    ${theme.spacings.unit(3)}
  `,
}));

export const SubHeaderContainer = styled('div')<{
  $cardIsBig: boolean;
}>(({ theme, $cardIsBig }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: $cardIsBig ? theme.spacings.unit(3) : theme.spacings.unit(1),
}));

export const ImageContainer = styled('div')<{
  $cardIsBig: boolean;
  $hasImage: boolean;
}>(({ theme, $cardIsBig, $hasImage }) => ({
  display: 'flex',
  height: $cardIsBig
    ? theme.spacings.unit(98)
    : $hasImage
      ? 'inherit'
      : theme.spacings.unit(54),
  maxHeight: $cardIsBig ? 'auto' : theme.spacings.unit(54),
  justifyContent: $cardIsBig ? 'unset' : 'center',
  borderRadius: theme.borders.roundness,
  overflow: 'hidden',
  alignSelf: $hasImage ? 'auto' : 'center',
}));

export const ImageStyled = styled('img')<{ $hasImage: boolean }>(
  ({ theme, $hasImage }) => ({
    overflow: 'hidden',
    mixBlendMode: 'multiply',
    objectFit: 'cover',
    objectPosition: 'center center',
    borderRadius: theme.borders.roundness,
    scale: $hasImage ? '1' : '0.5',
    width: $hasImage ? '100%' : 'auto',
  })
);
